const FORMAT = "dd.MM.yyyy";

export function parseDate(value: string): Date | null {
  if (!value || value.trim() === "") return null;
  const parts = value.trim().split(".");
  if (parts.length !== 3) return null;
  const [d, m, y] = parts.map(Number);
  if (Number.isNaN(d) || Number.isNaN(m) || Number.isNaN(y)) return null;
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatDate(date: Date | null): string {
  if (!date) return "";
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

export { FORMAT as DATE_DISPLAY_FORMAT };
